/**
 * Maps measurement types to human-readable labels
 * @param measurement - The measurement type string
 * @returns Human-readable measurement label
 */
const measurementLabels: Record<string, { full: string; short: string }> = {
  piece: { full: 'per stuk', short: 'st' },
  liter: { full: 'per liter', short: 'L' },
  kilogram: { full: 'per kg', short: 'kg' },
};

export const getMeasurementLabel = (measurement?: string): string => {
  if (!measurement) return 'per stuk';
  return measurementLabels[measurement]?.full ?? measurement;
};

export const getMeasurementShort = (measurement?: string): string => {
  if (!measurement) return '';
  return measurementLabels[measurement]?.short ?? measurement;
};

export function calcDiscount (gross: number, net: number): number {
  if (gross <= 0) return 0;
  return ((gross - net) / gross) * 100;
}

export function calcNetPrice (gross: number, discountPct: number): number {
  return gross * (1 - discountPct / 100);
}

export function calcSalesPrice (net: number, marginPct: number): number {
  return net * (1 + marginPct / 100);
}
